export interface IMarketplaceMetaData {
  amount: number;
  limit: number;
  offset: number;
}
